export const ROUTES = {
  main: '/',
  nft: '/nft/:id',
  search: '/search',
  terms: '/privacy',
  oAuth: '/oauth2/redirect',
  presentation: '/presentation'
};
